exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "news12-list{display:block}news12-list .down-arrow,news12-list .up-arrow{width:100%;padding:1vh;margin-left:20%}news12-list .down-arrow .up,news12-list .up-arrow .up{width:0;height:0;border-left:5vw solid transparent;border-right:5vw solid transparent;border-bottom:2vh solid #ffac25}news12-list .down-arrow .down,news12-list .up-arrow .down{width:0;height:0;border-left:5vw solid transparent;border-right:5vw solid transparent;border-top:2vh solid #ffac25}news12-list ul{font-size:3vmin;font-weight:400;list-style:none;margin:0;padding:0}news12-list ul li{padding:.5vh .5vh .75vh;font-size:3.5vmin}news12-list ul li:focus{outline:none;background-color:#353958}news12-list ul li:focus i{background:orange}news12-list label{display:block;cursor:pointer;user-select:none;-webkit-user-select:none;-webkit-touch-callout:none;margin-left:9%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}news12-list label>i{display:inline-block;vertical-align:middle;width:1vw;height:1vw;border-radius:50%;border:.2vw solid #fff;background:#4d48aa;margin-bottom:.4%;margin-right:.75%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/news12List/news12List.scss
 ** module id = 198
 ** module chunks = 0
 **/